module.exports = __webpack_public_path__ + "img/soja.2274d859.svg";